<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconRaiseHand_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M28.058 11.484c-.926-.273-1.883.305-2.14 1.289l-1.391 5.343-1.676-.492s2.527-9.705 2.782-10.689c.255-.984-.287-2.002-1.213-2.274-.925-.273-1.883.305-2.139 1.289l-2.782 10.688-1.676-.493 3.247-12.47c.257-.983-.287-2.001-1.212-2.274-.926-.273-1.883.305-2.14 1.289l-3.245 12.467-1.676-.493S15.324 4.96 15.58 3.976c.255-.984-.285-2.002-1.21-2.274-.926-.273-1.885.305-2.14 1.289L8.367 17.825c-.204.785-1.193.788-1.364-.006-.134-.618-.549-2.93-.843-4.588-.177-.991-1.061-1.656-2-1.502-.862.14-1.498.924-1.493 1.85.006 1.42.027 3.533.1 5.298.284 6.879 6.664 10.06 9.758 10.97 3.815 1.122 7.499 1.254 10.28-.632 1.915-1.298 3.43-3.799 4.157-6.59l2.308-8.867c.256-.984-.287-2.003-1.212-2.274Z"
    />
</svg>
